import useDeviceType from './useDeviceType';

export enum DeviceType {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}

export default function useAnalyticsDeviceType(): DeviceType {
  const { isMobile, isSmallLaptop } = useDeviceType();
  if (isMobile) return DeviceType.Mobile;
  if (isSmallLaptop) return DeviceType.Tablet;
  return DeviceType.Desktop;
}
